<div class="fx-layout-row fx-justify-space-between">
  <div class="fx-layout-row">
    <span>{{ field.label }}</span>
    @if (required) {
      <span matTooltipPosition="right" [matTooltip]="'TOOLTIP.REQUIRED_FIELD' | translate" class="required"> * </span>
    }
  </div>
  @if (computed) {
    <span matTooltipPosition="right" [matTooltip]="'TOOLTIP.COMPUTED_FIELD' | translate">
      <mat-icon fontSet="mdi" fontIcon="mdi-calculator" class="tooltip-icon"></mat-icon>
    </span>
  }
</div>
